import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = typeof obj?.[key] === 'object' ? toCamelCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

const toSnakeCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = typeof obj?.[key] === 'object' ? toSnakeCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

export const activityService = {
  // Get activities for user's company
  async getActivities(limit = 50) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('activities')?.select('*')?.order('created_at', { ascending: false })?.limit(limit);

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error fetching activities:', error?.message);
      throw error;
    }
  },

  // Create activity log
  async logActivity(activityData) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data: profile } = await supabase?.from('user_profiles')?.select('company_id, full_name')?.eq('id', user?.id)?.single();

      const snakeData = toSnakeCase({
        ...activityData,
        userId: user?.id,
        userName: profile?.full_name || 'Unknown User',
        companyId: profile?.company_id
      });

      const { data, error } = await supabase?.from('activities')?.insert(snakeData)?.select()?.single();

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error logging activity:', error?.message);
      throw error;
    }
  },

  // Get activities by catalog
  async getActivitiesByCatalog(catalogId) {
    try {
      const { data, error } = await supabase?.from('activities')?.select('*')?.eq('catalog_id', catalogId)?.order('created_at', { ascending: false });

      if (error) throw error;
      return toCamelCase(data);
    } catch (error) {
      console.error('Error fetching catalog activities:', error?.message);
      throw error;
    }
  }
};